import { useLanguage } from '../i18n';
import styles from './FilterTabs.module.css';

interface FilterTabsProps<T extends string> {
  filters: { id: T; label: string; count: number }[];
  activeFilter: T | 'all';
  onFilterChange: (filter: T | 'all') => void;
  totalCount: number;
}

// Map status to CSS class names (prefixed with status_ to avoid conflicts)
const statusClassMap: Record<string, string> = {
  active: styles.status_active, // Combined: buybox + pressure winners
  active_buybox_win: styles.status_active_buybox_win,
  active_pressure_winner: styles.status_active_pressure_winner,
  deactivated: styles.status_deactivated,
  not_activated: styles.status_not_activated,
  working: styles.status_active,
  waiting: styles.status_not_activated,
  inactive: styles.status_deactivated,
};

export function FilterTabs<T extends string>({
  filters,
  activeFilter,
  onFilterChange,
  totalCount,
}: FilterTabsProps<T>) {
  const { t } = useLanguage();

  return (
    <div className={styles.container}>
      <button
        className={`${styles.tab} ${activeFilter === 'all' ? styles.selected : ''}`}
        onClick={() => onFilterChange('all')}
      >
        <span className={styles.label}>{t.filters.all}</span>
        <span className={styles.count}>{totalCount}</span>
      </button>

      {filters.map((filter) => (
        <button
          key={filter.id}
          className={`${styles.tab} ${statusClassMap[filter.id] || ''} ${activeFilter === filter.id ? styles.selected : ''}`}
          onClick={() => onFilterChange(filter.id)}
        >
          <span className={styles.label}>{filter.label}</span>
          <span className={styles.count}>{filter.count}</span>
        </button>
      ))}
    </div>
  );
}
